// junip-item-image.ts

// Define the custom element class
 export class JunipItemImage extends HTMLElement {
  // Shadow DOM for encapsulation
  private shadow: ShadowRoot;
  private imgSrc: string;
  private imgAlt: string;
  private index: number;
  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: 'open' });

    // Get attributes or set defaults
    this.imgSrc = this.getAttribute('src') || 'https://via.placeholder.com/150';
    this.imgAlt = this.getAttribute('alt') || 'Item Image';
    this.index = parseInt(this.getAttribute('data-index') || '0');
    // Render the component
    this.render();
  }

  // Render the HTML and CSS
  private render(): void {
    this.shadow.innerHTML = /*html*/`
      <style>
        :host {
          display: block;
          cursor: pointer;
        }
        .thumbnail {
          width: 150px;
          height: 150px;
          object-fit: cover;
          border-radius: 8px;
        }
        .thumbnail:hover {
          opacity: 0.8;
        }
      </style>
      <img class="thumbnail" src="${this.imgSrc}" alt="${this.imgAlt}" />
    `;

    // Add event listeners
    this.addEventListeners();
  }

  // Set up event listeners for interactivity
  private addEventListeners(): void {
    const thumbnail = this.shadow.querySelector('.thumbnail') as HTMLImageElement;

    // Open modal on thumbnail click
    thumbnail.addEventListener('click', () => {
      
      const mediaModal = document.querySelector('junip-media-modal');
      const swiperEl = mediaModal?.shadowRoot?.querySelector('swiper-container') as any;
      // const swiperEl: any = document.querySelector('swiper-container')
      const reviewsModal = mediaModal?.shadowRoot?.querySelector('.reviews-modal');
      if (swiperEl && reviewsModal && swiperEl.swiper) {
        const swiper = swiperEl.swiper;
        swiper.slideTo(this.index, 0);
        setTimeout(() => {
          reviewsModal.classList.add('open');
        }, 10)
      }
    });
  }

  // Observe attribute changes
  static get observedAttributes(): string[] {
    return ['src', 'alt'];
  }

  // Handle attribute changes
  attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    if (oldValue !== newValue) {
      if (name === 'src') {
        this.imgSrc = newValue;
      } else if (name === 'alt') {
        this.imgAlt = newValue;
      }
      this.render();
    }
  }
}
